import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.concat.js";
// Copyright 2017-2022 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { objectSpread } from '@polkadot/util';
import * as defs from "./definitions.js";
var jsonrpc = {};
Object.keys(defs).forEach(function (s) {
  return Object.entries(defs[s].rpc || {}).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        method = _ref2[0],
        def = _ref2[1];

    // allow for section overrides
    var section = def.aliasSection || s;

    if (!jsonrpc[section]) {
      jsonrpc[section] = {};
    }

    jsonrpc[section][method] = objectSpread({}, def, {
      isSubscription: !!def.pubsub,
      jsonrpc: "".concat(section, "_").concat(method),
      method: method,
      section: section
    });
  });
});
export default jsonrpc;